/* Modulo How It Works — step accordion with smooth height transition + single/multi-open.
   The first step may be pre-opened in Liquid (open_first); this script normalizes its
   max-height on init so the close transition is smooth and no layout shift occurs.
   Vanilla IIFE, lazy-init via window.moduloLazyInit when available. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initSection(el) {
    if (el.dataset.hiwBound === '1') return;
    el.dataset.hiwBound = '1';

    var mode  = el.getAttribute('data-mode') === 'multi' ? 'multi' : 'single';
    var items = el.querySelectorAll('[data-modulo-hiw-item]');

    function close(item) {
      var content = item.querySelector('[data-modulo-hiw-content]');
      var trigger = item.querySelector('[data-modulo-hiw-trigger]');
      item.classList.remove('modulo-hiw__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (content) content.style.maxHeight = '0';
    }

    function open(item) {
      var content = item.querySelector('[data-modulo-hiw-content]');
      var trigger = item.querySelector('[data-modulo-hiw-trigger]');
      item.classList.add('modulo-hiw__item--open');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    }

    // Normalize any pre-opened item (open_first) from max-height:none to a px value.
    items.forEach(function (item) {
      if (!item.classList.contains('modulo-hiw__item--open')) return;
      var content = item.querySelector('[data-modulo-hiw-content]');
      if (content) content.style.maxHeight = content.scrollHeight + 'px';
    });

    items.forEach(function (item) {
      var trigger = item.querySelector('[data-modulo-hiw-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('modulo-hiw__item--open');

        if (mode === 'single' && !isOpen) {
          items.forEach(function (other) { if (other !== item) close(other); });
        }

        if (isOpen) close(item);
        else        open(item);
      });
    });

    // Recalc max-height on resize so wrapped answers don't get clipped.
    var resizeTimeout = null;
    window.addEventListener('resize', function () {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function () {
        items.forEach(function (item) {
          if (!item.classList.contains('modulo-hiw__item--open')) return;
          var content = item.querySelector('[data-modulo-hiw-content]');
          if (content) content.style.maxHeight = content.scrollHeight + 'px';
        });
      }, 100);
    }, { passive: true });
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-hiw]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-hiw]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
